/**
 * Standard import templates the studio fills in (Excel or Google Sheets, then save as CSV).
 * Headers must match what the server reads; the example rows show the expected formats.
 */

export const WORKER_TEMPLATE: string[][] = [
  ["worker_code", "name", "phone", "address", "pay_type", "day_rate", "hour_rate", "notes"],
  ["K_56", "Ganesh Gautam", "9839012345", "Lohta, Varanasi", "PIECE", "", "", ""],
  ["J_120", "Nandu Prajapati", "", "", "TIME", "400", "50", "helps on N05"],
];

export const RATE_TEMPLATE: string[][] = [
  ["design_number", "design_name", "work_type", "rate", "rate_unit", "alone_allowance", "daily_target_inches", "cutoff_percent", "bonus_percent", "effective_from"],
  ["DN-1497/HKV35", "Kadhua butidar", "S_1", "31.94", "inch", "15.54", "10", "75", "5", "2026-04-01"],
  ["DN-1497/HKV35", "", "S_2", "500/10.5", "girah", "", "", "", "", "2026-04-01"],
];

/** RFC 4180: quote fields with commas, quotes or line breaks. */
export const toCsv = (rows: string[][]): string =>
  rows
    .map((r) => r.map((v) => (/[",\n\r]/.test(v) ? `"${v.replace(/"/g, '""')}"` : v)).join(","))
    .join("\r\n") + "\r\n";

/** Save a CSV in the browser. The BOM makes Excel open UTF-8 (Hindi names) correctly. */
export const downloadCsv = (fileName: string, rows: string[][]) => {
  const blob = new Blob(["﻿" + toCsv(rows)], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.setTimeout(() => URL.revokeObjectURL(url), 1000);
};
